import { render, staticRenderFns } from "./PersonalDataComponent.vue?vue&type=template&id=d33b4dce&scoped=true&"
import script from "./PersonalDataComponent.vue?vue&type=script&lang=js&"
export * from "./PersonalDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataComponent.vue?vue&type=style&index=0&id=d33b4dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b4dce",
  null
  
)

component.options.__file = "PersonalDataComponent.vue"
export default component.exports